import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { IHelpInfo } from '../../models/i-help-info.interface';

@Component({
  selector: 'app-help-info-modal',
  templateUrl: './help-info-modal.component.html',
  styleUrls: ['./help-info-modal.component.scss']
})

export class HelpInfoModalComponent implements OnInit {
  @Input() helpInfo: IHelpInfo;
  heading = '';
  noButtonText = 'Close';
  noButtonColour = 'transparent';
  @Output() answer: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public modalRef: DynamicDialogRef) { }

  ngOnInit() {
    if (!this.helpInfo?.heading && this.helpInfo?.sections?.length > 0) {
      this.heading = this.helpInfo?.sections[0]?.heading;
    } else {
      this.heading = this.helpInfo?.heading;
    }
  }

  clicked(answer: boolean) {
    this.answer.emit(answer);
    this.modalRef.close();
  }
}
